require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/babel-polyfill/~/core-js/modules/es7.symbol.async-iterator.js
// module id = 627
// module chunks = 29